import React from 'react';

const Home = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
            <path d="M505.437 234.777L267.872 4.805c-6.617-6.407-17.124-6.407-23.741 0L6.565 234.777c-11.002 10.65-3.425 29.329 11.87 29.329H78.04v230.828c0 9.425 7.641 17.067 17.067 17.067h88.171V336.35c0-9.425 7.641-17.067 17.067-17.067h111.312c9.425 0 17.067 7.641 17.067 17.067V512h88.171c9.425 0 17.067-7.641 17.067-17.067V264.107h59.605c15.309 0 22.861-18.69 11.87-29.33z" />
        </svg>
        )
}

export default Home;
